import { Field } from 'formik'
import SkeletonLoader from '@/Layout/SkeletonLoader'

const FormikTextarea = (props) => {
    const { customClass, textareaProps, skeletonLoading } = props
    return (
        <>
            {skeletonLoading ? <SkeletonLoader height={138} rows={1} /> :
                <Field {...textareaProps} as="textarea" className={`${customClass} appearance-none bg-white border border-neutral-200 rounded-2xl w-full text-sm font-medium text-neutral-900 p-4 focus:outline-none focus:border-primary/60 focus:ring-4 focus:ring-primary/15 placeholder:text-neutral-400 placeholder:font-normal transition-all duration-150 resize-none`} />
            }
        </>
    )
}

export default FormikTextarea
